import $ from '@vaersaagod/tools/Dom';

export default (el, props) => {
    const $el = $(el);
    const $wrap = $el.find('[data-wrap]');
    const $moreLink = $el.find('[data-more-link]');
    const $moreLinkTextMore = $moreLink.find('[data-more-link-text-more]');
    const $moreLinkTextLess = $moreLink.find('[data-more-link-text-less]');
    const $moreLinkSign = $moreLink.find('[data-more-link-sign]');
    const $moreWrap = $el.find('[data-more-wrap]');
    
    let isExpanded = false;
    let timeout = -1;
    let tooltipVisible = false;
    let $tooltip = $('<div class="palette__tooltip">lorem</div>');
    
    const showMore = () => {
        $moreLinkTextMore.css({ display: 'none' });
        $moreLinkTextLess.css({ display: 'inline' });
        $moreLinkSign.text('–');
        $moreWrap.css({ display: 'flex' });
        
        isExpanded = true;
    };
    
    const showLess = () => {
        $moreLinkTextMore.css({ display: '' });
        $moreLinkTextLess.css({ display: '' });
        $moreLinkSign.text('+');
        $moreWrap.css({ display: '' });
        
        isExpanded = false;
    };
    
    const showTooltip = (colorName, pos) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            $tooltip.css({ opacity: 0, top: pos + 4 });
            $tooltip.text(props.colorLabel + ': ' + colorName);
            TweenMax.to($tooltip.get(0), 0.3, { opacity: 1, ease: 'Sine.easeOut' });
            tooltipVisible = true;
        }, tooltipVisible ? 150 : 50);
    };
    
    const hideTooltip = () => {
        clearTimeout(timeout);
        TweenMax.to($tooltip.get(0), 0.1, { opacity: 0, ease: 'Sine.easeOut', onComplete: () => {
            tooltipVisible = false;
        } });
    };
    
    const init = () => {
        $wrap.append($tooltip);
        $tooltip.css({ opacity: 0 });
        
        $el.find('[data-color-item]').on('mouseenter', e => {
            const $target = $(e.target);
            showTooltip($target.attr('aria-label'), $target.position().top + $target.height());
        });
        
        $el.find('[data-color-item]').on('mouseleave', () => {
            hideTooltip();
        });
        
        
        $moreLink.on('click', e => {
            e.preventDefault();
            if (isExpanded) {
                showLess();
            } else {
                showMore();
            }
        });
    };

    const destroy = () => {
        $moreLink.off('click');
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/ColorPalette.js